import React, { useEffect } from 'react';

const CerezSozlesmesi = () => {
  useEffect(() => {
    // Initialize AOS
    if (window.AOS) {
      window.AOS.init();
    }

    // Initialize Lucide Icons
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }, []);

  const cookieTypes = [
    {
      name: 'Zorunlu Çerezler',
      description: 'Web sitesinin temel işlevlerini yerine getirmek için gerekli olan çerezlerdir.',
      examples: ['Oturum yönetimi', 'Güvenlik', 'Form işlemleri'],
      necessary: true
    },
    {
      name: 'Performans Çerezleri',
      description: 'Web sitesinin performansını analiz etmek ve iyileştirmek için kullanılan çerezlerdir.',
      examples: ['Sayfa yükleme süreleri', 'Kullanıcı davranışları', 'Hata raporları'],
      necessary: false
    },
    {
      name: 'Fonksiyonel Çerezler',
      description: 'Kullanıcı deneyimini kişiselleştirmek için kullanılan çerezlerdir.',
      examples: ['Dil tercihi', 'Tema seçimi', 'Kullanıcı ayarları'],
      necessary: false
    },
    {
      name: 'Analitik Çerezler',
      description: 'Web sitesi kullanımını analiz etmek için kullanılan çerezlerdir.',
      examples: ['Google Analytics', 'Kullanıcı istatistikleri', 'Sayfa görüntüleme'],
      necessary: false
    }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-[72px] backdrop-blur-3xl">
        <div className="overlay"></div>
        <div className="stars" aria-hidden="true"></div>
        <div className="starts2" aria-hidden="true"></div>
        <div className="stars3" aria-hidden="true"></div>

        <div className="px-6 pt-20 overflow-hidden" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="800">
          <div className="container">
            <div className="py-14 text-center relative">
              <div className="flex justify-center">
                <div className="max-w-2xl">
                  <h2 className="md:text-6xl/tight text-5xl text-default-100 font-semibold mb-6">
                    <span className="bg-gradient-to-l from-rose-500 to-primary text-transparent bg-clip-text">Çerez Politikası</span>
                    <br />Çerez Kullanımı ve Yönetimi
                  </h2>
                  <p className="text-sm font-medium text-default-400 mt-5">
                    ISP Radius web sitesinde çerezlerin nasıl kullanıldığını ve çerez tercihlerinizi nasıl yönetebileceğinizi öğrenin.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-14">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="bg-default-950/40 backdrop-blur-3xl rounded-xl p-8">
              
              {/* Introduction */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000">
                <h3 className="text-2xl font-medium text-white mb-4">1. Çerez Nedir?</h3>
                <p className="text-base text-default-300 leading-relaxed">
                  Çerezler, web sitelerini ziyaret ettiğinizde tarayıcınız tarafından bilgisayarınıza veya mobil cihazınıza kaydedilen küçük metin dosyalarıdır. Bu dosyalar, web sitesinin daha iyi çalışmasını sağlar ve size daha iyi bir kullanıcı deneyimi sunar.
                </p>
              </div>

              {/* Cookie Types */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="100">
                <h3 className="text-2xl font-medium text-white mb-6">2. Kullandığımız Çerez Türleri</h3>
                <div className="grid md:grid-cols-2 gap-6">
                  {cookieTypes.map((cookie, index) => (
                    <div 
                      key={index}
                      className="p-6 rounded-lg bg-default-900/50 border border-white/10"
                      data-aos="fade-up" 
                      data-aos-easing="ease" 
                      data-aos-duration="1000"
                      data-aos-delay={100 + (index * 100)}
                    >
                      <div className="flex items-center justify-between mb-4">
                        <h4 className="text-lg font-medium text-white">{cookie.name}</h4>
                        <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                          cookie.necessary 
                            ? 'bg-green-500/20 text-green-400' 
                            : 'bg-blue-500/20 text-blue-400'
                        }`}>
                          {cookie.necessary ? 'Zorunlu' : 'Opsiyonel'}
                        </span>
                      </div>
                      <p className="text-sm text-default-300 mb-4">{cookie.description}</p>
                      <div>
                        <h5 className="text-sm font-medium text-default-200 mb-2">Örnekler:</h5>
                        <ul className="list-disc list-inside space-y-1">
                          {cookie.examples.map((example, exampleIndex) => (
                            <li key={exampleIndex} className="text-xs text-default-400">{example}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Cookie Management */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="500">
                <h3 className="text-2xl font-medium text-white mb-4">3. Çerez Tercihlerinizi Yönetme</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  Çerez tercihlerinizi aşağıdaki yöntemlerle yönetebilirsiniz:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-default-300 ml-4">
                  <li>Web sitemizdeki çerez ayarları panelini kullanarak</li>
                  <li>Tarayıcınızın ayarlar menüsünden çerezleri engelleyerek</li>
                  <li>Üçüncü taraf çerezleri engelleyerek</li>
                  <li>Çerezleri silerek</li>
                </ul>
              </div>

              {/* Browser Settings */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="600">
                <h3 className="text-2xl font-medium text-white mb-4">4. Tarayıcı Ayarları</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  Çerezleri tarayıcınızın ayarlarından yönetebilirsiniz:
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-default-900/50 rounded-lg p-4">
                    <h4 className="text-base font-medium text-white mb-2">Google Chrome</h4>
                    <p className="text-sm text-default-300">Ayarlar → Gizlilik ve güvenlik → Çerezler ve diğer site verileri</p>
                  </div>
                  <div className="bg-default-900/50 rounded-lg p-4">
                    <h4 className="text-base font-medium text-white mb-2">Mozilla Firefox</h4>
                    <p className="text-sm text-default-300">Ayarlar → Gizlilik ve Güvenlik → Çerezler ve Site Verileri</p>
                  </div>
                  <div className="bg-default-900/50 rounded-lg p-4">
                    <h4 className="text-base font-medium text-white mb-2">Safari</h4>
                    <p className="text-sm text-default-300">Tercihler → Gizlilik → Çerezleri ve web sitesi verilerini yönet</p>
                  </div>
                  <div className="bg-default-900/50 rounded-lg p-4">
                    <h4 className="text-base font-medium text-white mb-2">Microsoft Edge</h4>
                    <p className="text-sm text-default-300">Ayarlar → Çerezler ve site izinleri → Çerezler ve depolanan veriler</p>
                  </div>
                </div>
              </div>

              {/* Third Party Cookies */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="700">
                <h3 className="text-2xl font-medium text-white mb-4">5. Üçüncü Taraf Çerezler</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  Web sitemizde aşağıdaki üçüncü taraf hizmetlerin çerezleri kullanılabilir:
                </p>
                <div className="space-y-4">
                  <div className="bg-default-900/50 rounded-lg p-4">
                    <h4 className="text-base font-medium text-white mb-2">Google Analytics</h4>
                    <p className="text-sm text-default-300">Web sitesi trafiğini analiz etmek için kullanılır. Bu çerezleri Google'ın ayarlarından yönetebilirsiniz.</p>
                  </div>
                  <div className="bg-default-900/50 rounded-lg p-4">
                    <h4 className="text-base font-medium text-white mb-2">Sosyal Medya</h4>
                    <p className="text-sm text-default-300">Sosyal medya paylaşım butonları için kullanılır. İlgili platformların ayarlarından yönetebilirsiniz.</p>
                  </div>
                </div>
              </div>

              {/* Impact */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="800">
                <h3 className="text-2xl font-medium text-white mb-4">6. Çerezleri Engellemenin Etkisi</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  Çerezleri engellemeniz durumunda:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-default-300 ml-4">
                  <li>Web sitesinin bazı özellikleri düzgün çalışmayabilir</li>
                  <li>Kullanıcı tercihleriniz kaydedilmeyebilir</li>
                  <li>Oturum bilgileriniz korunmayabilir</li>
                  <li>Kişiselleştirilmiş içerik göremeyebilirsiniz</li>
                </ul>
              </div>

              {/* Contact */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="900">
                <h3 className="text-2xl font-medium text-white mb-4">7. İletişim</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  Çerez politikamız ile ilgili sorularınız için bizimle iletişime geçebilirsiniz:
                </p>
                <div className="bg-default-900/50 rounded-lg p-6">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <h4 className="text-base font-medium text-white mb-2">E-posta</h4>
                      <p className="text-sm text-default-300">info@kalemweb.com.tr</p>
                    </div>
                    <div>
                      <h4 className="text-base font-medium text-white mb-2">Telefon</h4>
                      <p className="text-sm text-default-300">+90 (850) 455 0164</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Updates */}
              <div data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="1000">
                <h3 className="text-2xl font-medium text-white mb-4">8. Güncellemeler</h3>
                <p className="text-base text-default-300 leading-relaxed">
                  Bu Çerez Politikası gerektiğinde güncellenebilir. Önemli değişiklikler durumunda kullanıcılarımızı bilgilendiririz. Güncel sürümü web sitemizde bulabilirsiniz.
                </p>
                <p className="text-sm text-default-400 mt-4">
                  Bu politika güncel ve yürürlüktedir.
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CerezSozlesmesi;

